import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const autoRenewalBannerEnabled = isFeature('auto-renewal-banner-enabled');
export const unbindCardBannerEnabled = isFeature('unbind-card-banner-enabled');
